export function isSizeLarge(size) {
  return size === 'large' || size === 'lg';
}
export function isSizeSmall(size) {
  return size === 'small' || size === 'sm';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-typeahead/es/utils/size.js
// module id = 1018
// module chunks = 31